import {mapState} from "vuex";
import apiService from "@/services/apiService";
import localStorageService from "@/services/localStorageService";
import handleIndexedDB from '@/services/indexedDB';
import dayjs from 'dayjs';

export default {
    computed: {
        ...mapState(["teams", "score"]),
    },
    methods: {
        getTeamPlayerById(playerId) {
            for (let team of this.teams) {
                const player = team.players.find((p) => p.id === playerId);
                if (player) {
                    return player;
                }
            }
            return null;
        },
        getGamePlayerById(playerId) {
            // Spieler in "home.players" durchsuchen
            const homePlayer = this.game.home.players.find(player => player.id === playerId);
            if (homePlayer) {
                return homePlayer; // Spieler in "home.players" gefunden
            }

            // Spieler in "guest.players" durchsuchen
            const guestPlayer = this.game.guest.players.find(player => player.id === playerId);
            if (guestPlayer) {
                return guestPlayer; // Spieler in "guest.players" gefunden
            }

            return null; // Kein Spieler gefunden
        },
        shortName(name) {
            // Teile den Namen bei Leerzeichen auf
            const nameSplit = name.split(" ");

            // Wenn der Name nur einen Teil hat, gib ihn unverändert zurück
            if (nameSplit.length < 2) return name;

            // Behalte den ersten Teil (z. B. Vorname) unverändert
            const firstName = nameSplit[0];

            // Kürze den Rest: Nimm den ersten Buchstaben jedes anderen Teils
            const shortenedParts = nameSplit.slice(1).map((part) => part[0] + ".");

            // Kombiniere den unveränderten ersten Teil mit den gekürzten restlichen Teilen
            return [firstName, ...shortenedParts].join(" ");
        },
        postData(endpoint, data) {
            if(localStorageService.get('useApi') === true) {
                apiService.post(endpoint, data)
            }
            handleIndexedDB(endpoint, data);
        },
        async getScore() {
            if (!this.score.inning.length > 0) {
                const gameId = localStorage.getItem('currentgame');
                if (!gameId) {
                    throw new Error('Kein Spiel gefunden.');
                }

                const score = await this.getData('getScore', { id: gameId });
                console.log('Score ist leer, lade Daten...', score.score, gameId);
                return score.score
            }
        
            return this.score;
        },
        getData(endpoint, params, type = 'api') {
            // if(type !== 'local' && localStorageService.get('useApi')) {
            //     return apiService.get(endpoint + '/' + params)
            // }
            console.log(handleIndexedDB(endpoint, params), type)
            return handleIndexedDB(endpoint, params);
        },
        formatDate(timestamp, format = 'DD.MM.YYYY') {
            if (!timestamp) return '';
            return dayjs(timestamp).format(format);
          }
    }
}